import { UUID_REGEX } from '../../../constants';
import type { Hub, Org } from '../entitlementsHelper/entitlementsHelper';

export const DEEPLINK_KEY = 'deeplinkPath';

export function setDeeplink(deeplinkPath: string): void {
    // Don't set blank deep links, so that our defaultHomePath can override the deeplink.
    if (!deeplinkPath || ['/', ''].includes(deeplinkPath)) {
        return;
    }
    sessionStorage.setItem(DEEPLINK_KEY, deeplinkPath);
}

export function getDeeplink(defaultHomePagePath = '/'): string {
    // avoid any malicious URLS being put into session storage, the catch is our happy path
    try {
        new URL(sessionStorage.getItem(DEEPLINK_KEY) || '');
    } catch (_error) {
        return sessionStorage.getItem(DEEPLINK_KEY) || defaultHomePagePath;
    }
    return defaultHomePagePath;
}

export function clearDeeplink(): void {
    sessionStorage.removeItem(DEEPLINK_KEY);
}

export function getOrgFromDeeplink(
    deepLink: string,
    organizations: Org[] | undefined,
): Org | undefined {
    const uuidsFromDeeplink = deepLink.match(UUID_REGEX);
    if (!uuidsFromDeeplink || !uuidsFromDeeplink.length) {
        return undefined;
    }

    if (!organizations) {
        return undefined;
    }

    const orgFromDeeplink = organizations.find((org: Org) => org.id === uuidsFromDeeplink[0]);
    return orgFromDeeplink;
}

/**
 * Attempts to get the hub from the deeplink, which has different formats.
 * Evo deeplink to BlockSync are in the format: /{orgId}/{hubCode}/{workspaceId}/blockmodel/{blockmodelId}
 * BlockSync deeplink to Evo are in the format: /{orgId}/workspaces/{hubCode}/{workspaceId}/overview?id=/{blockmodelId}
 * @param deepLink the value passed by caller, hopefully read from the LocalStorage
 * @param hubs the list of hubs returned from the entitlements API
 * @returns the Hub object if found, otherwise undefined
 */
export function getHubFromDeeplink(deepLink: string, hubs: Hub[] | undefined): Hub | undefined {
    const deepLinkPaths = deepLink.split('/');
    const presumedHubCode =
        deepLinkPaths.length >= 4 && deepLinkPaths[2] === 'workspaces'
            ? deepLinkPaths[3]
            : deepLinkPaths[2];
    return hubs?.find((hub: Hub) => hub.code === presumedHubCode);
}
